import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import Core from "../Core";

import { Button, Form, FormGroup, ControlLabel, FormControl } from "react-bootstrap";

class ApplicationDetailPage extends Component {
    currentApplication() {
        const { stores, id } = this.props;
        const application = stores.data.ApplicationsStore.findById(id);
        return application;
    }

    handleChange(key, e) {
        const application = this.currentApplication();
        if (application) {
            let value = e.target.value;
            if (value === "") value = null;
            application[key] = value;
        }
    }

    onSaveClick() {
        const application = this.currentApplication();
        if (application) {
            application.store.storeModel(application, () => {
                window.location.hash = `#applications-list`;
            });
        }
    }

    onCancelClick() {
        window.history.back();
    }

    validateValue(value, required = true) {
        let validationState = null;

        if (required && (value === null || value === undefined || value.length === 0)) {
            validationState = "error";
        }

        return validationState;
    }

    render() {
        const application = this.currentApplication();
        if (!application) throw new Error("Application cannot be null");

        return (
            <div>
                <div className="row">
                    <h1>Application details</h1>
                </div>

                <Form className="well">
                    <div className="row">
                        <FormGroup className="col-sm-2" validationState={this.validateValue(application.Number, true)}>
                            <ControlLabel>Number</ControlLabel>

                            <Core.Components.Inputs.Text type={"number"} model={application} dataMember={"Number"} required={true} />
                        </FormGroup>
                    </div>

                    <div className="row">
                        <FormGroup className="col-sm-4" validationState={this.validateValue(application.Name, true)}>
                            <ControlLabel>Name</ControlLabel>
                            <Core.Components.Inputs.Text type={"text"} model={application} dataMember={"Name"} />
                        </FormGroup>
                    </div>

                    <div className="row">
                        <FormGroup className="col-sm-2" validationState={this.validateValue(application.HasTrial, true)}>
                            <ControlLabel>Has trial</ControlLabel>
                            <FormControl
                                componentClass="select"
                                placeholder="select"
                                value={application.HasTrial}
                                onChange={this.handleChange.bind(this, "HasTrial")}
                            >
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </FormControl>
                        </FormGroup>
                    </div>

                    <div className="row">
                        <FormGroup className="col-sm-2" validationState={this.validateValue(application.Notify, true)}>
                            <ControlLabel>Notify</ControlLabel>
                            <FormControl componentClass="select" placeholder="select" value={application.Notify} onChange={this.handleChange.bind(this, "Notify")}>
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </FormControl>
                        </FormGroup>
                    </div>

                    <div className="row">
                        <FormGroup className="col-sm-4">
                            <ControlLabel>Email to notify</ControlLabel>
                            <Core.Components.Inputs.Text type={"text"} model={application} dataMember={"EmailToNotify"} />
                        </FormGroup>
                    </div>

                    <div className="row">
                        <FormGroup className="col-sm-4">
                            <ControlLabel>Last updated</ControlLabel>
                            <Core.Components.Inputs.Date readOnly={"readOnly"} model={application} timeFormat={true} dataMember={"LastUpdated"} />
                        </FormGroup>
                    </div>

                    <div className="row">
                        <div className="pull-right">
                            <Button bsStyle="primary" onClick={this.onSaveClick.bind(this)}>
                                Save
                            </Button>
                            <Button bsStyle="link" onClick={this.onCancelClick.bind(this)}>
                                Cancel
                            </Button>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}

export default inject("stores")(observer(ApplicationDetailPage));



// WEBPACK FOOTER //
// ./src/Pages/ApplicationDetailPage.js